<template>
  <div class="app-container">
    <BjDivider>
      {{ $t('BusinessPurchaseReturnComDetail.purchaseText') }}{{ text }}{{ $t('BusinessPurchaseReturnComDetail.statusText') }}
      <template #right>
        <el-button v-if="pageType === 'inform'" type="primary" @click="showLog">{{ $t('BusinessPurchaseReturnComDetail.operationLog') }}</el-button>
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
      </template>
    </BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col bj-col-24">
        <div class="bj-form-title">
          {{ $t('BusinessPurchaseReturnComDetail.statusMeaning') }}: <span class="red">{{ data.statusMeaning }}</span>
        </div>
        <div class="flex-center">
          <div v-show="pageType === 'inform'" class="text-center numBox">
            <p>{{ $t('BusinessPurchaseReturnComDetail.planQty') }}</p>
            <span>{{ data.planQty || 0 }}</span>
          </div>
          <div class="text-center numBox">
            <p>{{ $t('BusinessPurchaseReturnComDetail.alreadyQty') }}</p>
            <span>{{ data.alreadyQty || 0 }}</span>
          </div>
          <div v-show="pageType === 'inform'" class="text-center numBox">
            <p>{{ $t('BusinessPurchaseReturnComDetail.waitQty') }}</p>
            <span>{{ data.waitQty || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
    <BjDivider> {{ $t('BusinessPurchaseReturnComDetail.purchaseText') }}{{ text }}{{ $t('BusinessPurchaseReturnComDetail.informationText') }} </BjDivider>
    <div class="bj-row mt20">
      <div class="bj-col">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.stockoutCode') }}</div>
          <div class="bj-form-item-value">
            {{ pageType === 'inform' ? data.code : data.stockoutCode }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.resultCode') }}</div>
          <div class="bj-form-item-value">
            {{ pageType === 'inform' ? data.stockoutResultCodeList.join() : data.code }}
          </div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.typeMeaning') }}</div>
          <div class="bj-form-item-value">{{ data.typeMeaning }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.supplierName') }}</div>
          <div class="bj-form-item-value">{{ data.supplierName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.warehouseName') }}</div>
          <div class="bj-form-item-value">{{ data.warehouseName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.purchaseCode') }}</div>
          <div class="bj-form-item-value">{{ data.purchaseCode }}</div>
        </div>
      </div>
      <div class="bj-col">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.creatorText') }}</div>
          <div class="bj-form-item-value">{{ data.createdName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.createTimeText') }}</div>
          <div class="bj-form-item-value">{{ data.creationDate }}</div>
        </div>
        <div v-if="pageType === 'inform'" class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.auditDate') }}</div>
          <div class="bj-form-item-value">{{ data.auditDate }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.stockoutDate') }}</div>
          <div class="bj-form-item-value">{{ data.stockoutDate }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('table.remarkText') }}</div>
          <div class="bj-form-item-value">{{ data.remark }}</div>
        </div>
      </div>
      <div class="bj-col">
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.logisticsBusinessName') }}</div>
          <div class="bj-form-item-value">{{ data.logisticsBusinessName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.logisticsNo') }}</div>
          <div class="bj-form-item-value">{{ data.logisticsNo }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.recipientName') }}</div>
          <div class="bj-form-item-value">{{ data.recipientName }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.recipientPhone') }}</div>
          <div class="bj-form-item-value">{{ data.recipientPhone }}</div>
        </div>
        <div class="bj-form-item">
          <div class="bj-form-item-label">{{ $t('BusinessPurchaseReturnComDetail.recipientAddress') }}</div>
          <div class="bj-form-item-value">
            {{
              (data.recipientProvince || '') +
                (data.recipientCity || '') +
                (data.recipientDistrict || '') +
                (data.recipientAddress || '')
            }}
          </div>
        </div>
      </div>
    </div>
    <BjDivider>
      {{ $t('BusinessPurchaseReturnComDetail.table.title') }}
    </BjDivider>
    <el-table :data="data.goodsList" border script max-height="600">
      <el-table-column :label="$t('table.countText')" type="index" width="65" align="center" />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.spuPic')" prop="spuPic" align="center">
        <template slot-scope="{ row }">
          <BjViewUrl :url="(JSON.parse(row.spuPic) || [])[0]" height="60px" preview />
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('goodsPage.spuCode')" prop="spuCode" align="center" />
      <el-table-column :label="$t('goodsPage.spuName')" prop="spuName" align="center" /> -->
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.skuCode')" prop="skuCode" align="center" />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.skuName')" prop="skuName" align="center" />
      <el-table-column
        v-if="pageType === 'inform'"
        :label="$t('BusinessPurchaseReturnComDetail.table.planQty')"
        prop="planQty"
        align="center"
        width="150"
      />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.alreadyQty')" prop="alreadyQty" align="center" />
      <el-table-column
        v-if="pageType === 'inform'"
        :label="$t('BusinessPurchaseReturnComDetail.table.waitQty')"
        prop="waitQty"
        align="center"
        width="150"
      />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.taxUnitPrice')" width="110" prop="taxUnitPrice" align="center" />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.taxRate')" prop="taxRate" width="100" align="center">
        <template slot-scope="{ row }"> {{ row.taxRate }}% </template>
      </el-table-column>
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.taxPrice')" prop="taxPrice" width="120" align="center" />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.supplierSpuCode')" width="130" prop="supplierSpuCode" align="center" />
      <el-table-column :label="$t('BusinessPurchaseReturnComDetail.table.supplierSkuCode')" width="110" prop="supplierSkuCode" align="center" />
    </el-table>
  </div>
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { purchaseApi } from '@/api';
import orderLog from '@/utils/log.js';
export default {
  mixins: [viewMiXin],
  props: {
    pageType: {
      type: String,
      default: 'inform',
      validator: value => {
        return ['inform', 'result'].includes(value);
      },
    },
  },
  data() {
    return { data: {} };
  },
  computed: {
    text() {
      return this.pageType === 'inform' ? this.$t('BusinessPurchaseReturnComDetail.notify') : this.$t('BusinessPurchaseReturnComDetail.result');
    },
  },
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    showLog() {
      orderLog(
        this.$BjDialogListConfig['purchaseDefault'](
          `${this.$t('BusinessPurchaseReturnComDetail.purchaseText')}${this.text}${this.$t('BusinessPurchaseReturnComDetail.one')}${this.$route.query.code}${this.$t('BusinessPurchaseReturnComDetail.log')}`,
          {
            defaultQuery: {
              recordId: this.data.id,
              recordType: this.pageType === 'inform' ? 'STOCKOUT' : 'STOCKOUT_RESULT',
            },
            search: [],
          },
        ),
      );
    },
    handleClose() {
      this.cancel();
    },
    getData() {
      purchaseApi[this.pageType === 'inform' ? 'getStockoutsDetail' : 'getStockoutResultsDetail']({
        // id: this.$route.query.id,
        code: this.$route.query.code,
      }).then(res => {
        if (!res.failed) {
          this.data = res;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-center {
  justify-content: left;
}
.numBox {
  position: relative;
  flex: 0 0 100px;
  padding-bottom: 15px;
}
.numBox p {
  font-size: 12px;
}
.numBox::after {
  position: absolute;
  content: '';
  height: 5px;
  bottom: 0;
  left: 15px;
  right: 15px;
  display: block;
  // background-color: red;
}
.numBox:nth-child(1):after {
  background-color: $main-dark;
}
.numBox:nth-child(2):after {
  background-color: $green;
}
.numBox:nth-child(3):after {
  background-color: $sub-dark;
}
</style>
